// extracted by mini-css-extract-plugin
export default {"sidepanel_body":"PageLayout_sidepanel_body__Ar4Bn","content":"PageLayout_content__abaAl"};